import { useEffect } from "react";

// Lightweight per-page SEO helper (title + meta description + canonical + OG)
export default function useSeo({
  title,
  description,
  path = "",
  noindex = false,
} = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} · Alex Buchner Health`
      : "Alex Buchner Health – Personal Training & Mikronährstoffberatung";
    document.title = fullTitle;

    const setMeta = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [_, key, val] = selector.match(/\[(.+?)=["']?(.+?)["']?\]/) || [];
        if (key && val) el.setAttribute(key, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    if (description) {
      setMeta('meta[name="description"]', "content", description);
      setMeta('meta[property="og:description"]', "content", description);
    }
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:type"]', "content", "website");
    setMeta('meta[property="og:locale"]', "content", "de_DE");
    setMeta(
      'meta[property="og:site_name"]',
      "content",
      "Alex Buchner Health"
    );
    setMeta('meta[name="robots"]', "content", noindex ? "noindex,nofollow" : "index,follow");

    // Canonical
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    const base = "https://www.alex-buchner-health.de";
    canonical.setAttribute("href", `${base}${path || ""}`);
  }, [title, description, path, noindex]);
}
